/* Swap the still in the "Record a video message" panel.

   The picture is normally supplied by rockkt-media.js, a 1.4MB file of base64
   images keyed m0 to m43, applied by a one-line inline script straight after it
   loads. Editing that file to change one photograph is not practical: the whole
   thing would have to be rewritten and re-uploaded to change 38KB of it.

   So the new photograph goes in as an ordinary theme asset and this points the
   one <img> at it afterwards. The asset URL is written by the layout into
   window.RK_PV_STILL, because Liquid's asset_url is only available there.

   Nothing else in the panel is touched. The recording pill, the "Branded frame
   · on" tag and the Northwind mark are all separate elements sitting on top of
   the image, and they stay exactly where they are.

   Two passes. The inline script that applies RKMEDIA runs during parse, so a
   pass at DOM ready is already after it; the pass on load is there in case the
   media file arrives late and the inline script has not run yet by then. The
   data attribute makes the second pass a no-op when the first one worked. */
(function () {
  var SEL = 'img.pv-img[data-media="m14"]';

  function swap() {
    var url = window.RK_PV_STILL;
    if (!url) return;
    var img = document.querySelector(SEL);
    if (!img) return;
    if (img.getAttribute('data-rk-still') === '1' && img.getAttribute('src') === url) return;
    img.setAttribute('src', url);
    img.setAttribute('data-rk-still', '1');
    /* The old still was a portrait crop and the panel is square, so the page
       pulled the framing up with object-position. This one is already square
       and needs none of that. */
    img.style.objectPosition = 'center center';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', swap);
  else swap();
  window.addEventListener('load', swap);
})();
